import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController, PopoverController } from '@ionic/angular';
import { FileService } from '../../services/file.service'
import { ViewAssetModalPage } from '../view-asset-modal/view-asset-modal.page';
import { BaseAsset } from 'src/app/models/assets/BaseAsset';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { ValidationService } from 'src/app/services/validation.service';
import { MediaAsset } from 'src/app/models/assets/MediaAsset';
import { FileUploadInfoComponent } from '../../popovers/file-upload-info/file-upload-info.component'
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { AssetIsBackgroundInformationPopoverComponent } from 'src/app/popovers/asset-is-background-information-popover/asset-is-background-information-popover.component';

@Component({
  selector: 'app-add-asset-modal',
  templateUrl: './add-asset-modal.page.html',
  styleUrls: ['./add-asset-modal.page.scss'],
})
export class AddAssetModalPage implements OnInit {

  public asset: BaseAsset = new BaseAsset();
  public assetType: string = "";
  public isEditing;
  public fileUploaded: boolean = false;
  public isVideo: boolean = false;
  public compressVideo: boolean = false;
  public isBackground: boolean = false;
  public oldSrc: string;
  public isModalOpen: boolean = false;

  constructor(
    public modalController: ModalController,
    public fileService: FileService,
    public assetTypeService: AssetTypeService,
    public validationService: ValidationService,
    public popoverController: PopoverController,
    public unfocusService: UnfocusElementService,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    document.querySelector('#asset-name-input').focus();
    if (this.isEditing == true) {
      this.validationService.setUploadFileType(this.getAssetType(this.asset.assetTypeId));
    }

    if (this.asset["src"] && this.asset["src"] != "") {
      this.oldSrc = this.asset["src"];
    }
  }

  closeModal() {
    this.modalController.dismiss();
  }

  async showFileUploadInfoPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: FileUploadInfoComponent,
      event: ev,
      translucent: true,
    });

    return await popover.present();
  }

  async saveMediaAsset(event, files) {
    this.unfocusService.unfocus(event);
    this.asset.name = this.validationService.removeHtmlTags(this.asset.name);

    if (!this.validationService.isMediaAssetValid(this.asset as MediaAsset)) {
      this.validationService.alertForMissingAssetProperties(this.asset);
    } else if (this.asset.name.length > 40) {
      this.validationService.createAlert('File name is too long. Please shorten to 40 characters.');
    }
    else if (this.fileUploaded == true && !this.validationService.doesUploadedFileMatchAssetType(this.asset.assetTypeId)) {
      this.validationService.createAlert('Wrong Asset Type Uploaded.');
    } else if (this.fileUploaded == true && !this.validationService.isFileFormatCorrect(this.asset.assetTypeId)) {
      this.validationService.createAlert('Unsupported File Format.');
    } else {
      if (this.fileUploaded == true) {
        let mediaAsset: MediaAsset = this.asset as MediaAsset;
        mediaAsset.src = await this.uploadFile(files);
      }

      this.isBackground = this.assetType == 'Audio' ? false : this.isBackground; //Extra validation;

      let data = {
        asset: this.asset,
        assetType: this.assetType,
        isBackground: this.isBackground
      }
      this.modalController.dismiss(data);
    }

  }

  setUpFileType(event) {
    if (event.target.files.length > 0) {
      this.fileUploaded = true;
    }
    var type: string = event.target.files[0].type;
    if (type.startsWith('image')) {
      this.assetType = 'Image';
      this.asset.assetTypeId = this.assetTypeService.getId('Image');
    } else if (type.startsWith('audio') || type.endsWith('ogg')) {
      this.isBackground = false;
      this.assetType = 'Audio';
      this.asset.assetTypeId = this.assetTypeService.getId('Audio');
    } else if (type.startsWith('video')) {
      this.assetType = 'Video';
      this.asset.assetTypeId = this.assetTypeService.getId('Video');
      this.isVideo = true;
    }
    this.asset.mediaFileExtension = this.getFileExtension(event.target.files[0].name);
    this.validationService.setFileType(event);
  }

  getFileExtension(fileName: string): string {
    return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) || fileName;
  }

  selectFile(event) {
    if (!this.asset.name || this.asset.name.trim().length == 0) this.asset.name = event.target.files[0].name.length > 40 ? event.target.files[0].name.slice(0, 40) : event.target.files[0].name;
    this.asset["src"] = URL.createObjectURL(event.target.files[0]);
    //this.fileService.fileEvent($event, '5a0ffb5a-475d-4307-bf05-237f82a9302d', this.asset, 'src');
  }

  uploadFile(files): Promise<string> {
    return this.fileService.fileEventUpload(files, '5a0ffb5a-475d-4307-bf05-237f82a9302d', this.compressVideo);
  }

  getAssetType(id): string {
    return this.assetTypeService.getType(id);
  }

  cancelModal() {
    if (this.oldSrc) {
      this.asset["src"] = this.oldSrc;
    }
    this.modalController.dismiss();
  }

  async launchAssetPreview() {

    if (this.isModalOpen === true) return;
    this.isModalOpen = true;

    const oldSrc = this.asset['src'];
    this.asset['src'] = this.sanitizer.bypassSecurityTrustUrl(this.asset['src']);

    const modal = await this.modalController.create({
      component: ViewAssetModalPage,
      id: 'asset-preview-' + this.assetTypeService.getType(this.asset.assetTypeId) + '-modal',
      componentProps: {
        "assetModalData": this.asset
      }
    });

    modal.onDidDismiss().then(() => {
      this.isModalOpen = false;
      this.asset['src'] = oldSrc;
    });

    return await modal.present();
  }

  async displayIsBackgroundInformation(event) {
    this.unfocusService.unfocus(event);
    const popover = await this.popoverController.create({
      component: AssetIsBackgroundInformationPopoverComponent,
      event: event,
      translucent: true,
      componentProps: {
        "isEditing": this.isEditing,
        "assetType": this.assetType
      }
    });
    return await popover.present();
  }
}
